const hour = {
    init() {
        // Overtime form
        this.overtimeButton = document.querySelector('.hourtarget .overtimeButton');
        this.overtimeForm = document.querySelector('.hourtarget .hour-form');
        this.successText = document.querySelector('.hourtarget .success-text')

        // Copies the start time to the end time when filled in.
        this.watchTime();
        this.watchOvertime();

        // Opens overtime form on button click
        this.openOvertimeForm();

        // Enables the 'to' input if the 'from' input is filled.
        this.firstInputListener();

        this.watchDownloadWeeks();
    },

    watchDownloadWeeks() {
        let week1 = document.querySelector('#week1');
        let week2 = document.querySelector('#week2');
        let count = document.querySelector('#week-count');

        if (!week1 || !week2) {
            return;
        }

        let update = function () {
            let start = week1.value;

            // Option values are Y-m-d Mondays, so string comparison equals date comparison.
            Array.from(week2.options).forEach(function (option) {
                option.disabled = start !== '' && option.value !== '' && option.value < start;
            });

            if (start !== '' && week2.value !== '' && week2.value < start) {
                week2.value = start;
            }

            if (start === '' || week2.value === '') {
                count.textContent = '';
                return;
            }

            let weeks = Math.round((new Date(week2.value) - new Date(start)) / (7 * 24 * 60 * 60 * 1000)) + 1;
            count.textContent = weeks === 1 ? 'Dit is 1 week.' : 'Dit zijn ' + weeks + ' weken.';
        };

        week1.addEventListener('change', update);
        week2.addEventListener('change', update);
        update();
    },


    watchTime() {
        let time1 = document.querySelector('.hourtarget #time1');
        let time2 = document.querySelector('.hourtarget #time2');

        if (time1) {
            time1.addEventListener('blur', function () {
                time2.value = this.value;
            })
        }
    },

    watchOvertime() {
        let overtime1 = document.querySelector('.hourtarget #overtime1');
        let overtime2 = document.querySelector('.hourtarget #overtime2');

        if (overtime1) {
            overtime1.addEventListener('blur', function () {
                overtime2.value = this.value;
            })
        }
    },

    openOvertimeForm() {
        if (this.overtimeButton) {
            let hour = this;

            this.overtimeButton.addEventListener('click', function (e) {
                e.preventDefault();

                hour.overtimeForm.classList.remove('d-none');
                hour.successText.classList.add('d-none');
                this.classList.add('d-none');

                hour.watchOvertime();
            });
        }
    },

    firstInputListener() {
        $('.time-input').on('change', this.enableNextInput.bind(this));
    },

    enableNextInput(e) {
        let nextInput = $(e.currentTarget).data('next');
        $(nextInput).removeAttr('disabled');
    }

};

hour.init();
